// @ts-nocheck -- This file had typechecking errors that must be resolved by hand

// Taken from:
// https://www.npmjs.com/package/react-children-utilities
//
// This package is currently available only as an ES module which
// is causing build and runtime errors in our consumer's ecosystems
// when they try render on the Server (Node 12 doesn't support ESM out of the box)
//
// react-children-utilities License
//
// The MIT License (MIT)
//
// Copyright (c) 2018 Fernando Pasik
//
// Permission is hereby granted, free of charge, to any person obtaining a copy of
// this software and associated documentation files (the "Software"), to deal in
// the Software without restriction, including without limitation the rights to
// use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
// the Software, and to permit persons to whom the Software is furnished to do so,
// subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
// FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
// COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
// IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
// CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

import { Children, isValidElement } from 'react';

const hasChildren = (element?: any) => isValidElement(element) && Boolean(element.props.children);

const childToString = (child?: any) => {
  if (typeof child === 'undefined' || child === null || typeof child === 'boolean') {
    return '';
  }
  return child.toString();
};

const onlyText = (children?: any) => {
  if (!(children instanceof Array) && !isValidElement(children)) {
    return childToString(children);
  }

  return Children.toArray(children).reduce((text?: any, child?: any) => {
    let newText;

    if (isValidElement(child) && hasChildren(child)) {
      newText = onlyText(child.props.children);
    } else {
      newText = childToString(child);
    }

    return text.concat(newText);
  }, '');
};

export default onlyText;
